import React from "react";

export const IconArrowRight = ({ handleClick = false }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9776 10.0011L10.4687 3.49219L9.58486 4.37607L14.5848 9.37598H3.28125V10.626H14.585L9.58486 15.6261L10.4687 16.51L16.9776 10.0011Z"
      fill="#424242"
    />
  </svg>
);

export default IconArrowRight;
